import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../../context/context";

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: FC<AdminRouteProps> = ({ children }) => {
  const { context_state } = useAppContext();

  return context_state.account.admin ? (
    children
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default AdminRoute;
